import { render, staticRenderFns } from "./EfnInfoDialog.vue?vue&type=template&id=23216cb3&"
import script from "./EfnInfoDialog.vue?vue&type=script&lang=js&"
export * from "./EfnInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports